import React, { useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector, useExtraLiquidID } from '@pkg/hooks';

import { useIsPreview } from '@app/pages/ProfilePage/hooks/useIsPreview';
import { setLiquidIdEditStage, updateYatPageEditStates } from '@app/store/slices';
import { LiquidIDEditStage } from '@app/store/slices/yat-page/types';

import { EditButton, LiquidIdStyled, Wrapper } from './LiquidId.style';

export function LiquidId() {
    const navigate = useNavigate();
    const eid = useAppSelector((state) => state.yatPage.eid);
    const user_id = useAppSelector((state) => state.yatPage.user_id);
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const dispatch = useAppDispatch();

    const isPreview = useIsPreview();

    const wrapperRef = useRef<HTMLDivElement>(null);

    const mouse = useRef({ x: 0, y: 0 });

    const onLiquidIdMouseDown = (event: React.MouseEvent) => {
        mouse.current.x = event.clientX;
        mouse.current.y = event.clientY;
    };

    const onLiquidIdMouseUp = (event: React.MouseEvent) => {
        const x = event.clientX - mouse.current.x;
        const y = event.clientY - mouse.current.y;
        if (Math.sqrt(x * x + y * y) < 10) onLiquidIdClick();
    };

    const onLiquidIdClick = () => {
        if (isPageOwner && !isPreview) {
            dispatch(setLiquidIdEditStage(LiquidIDEditStage.Selection));
            dispatch(updateYatPageEditStates({ editingLiquidID: true }));
        }

        if (eid) navigate(`/${eid}?lid=1`, { state: { enableGoBack: true } });
    };

    useExtraLiquidID({
        ownerID: user_id || undefined,
        wrapperRef: wrapperRef,
        isScrollingElement: true,
        backgroundVisibility: true,
        delayRender: 1000,
    });

    const [isHovering, setIsHovering] = useState(false);

    return (
        <Wrapper
            onMouseDown={onLiquidIdMouseDown}
            onMouseUp={onLiquidIdMouseUp}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <LiquidIdStyled ref={wrapperRef} />
            {isPageOwner && !isPreview && (
                <AnimatePresence>
                    {isHovering && (
                        <EditButton
                            onClick={onLiquidIdClick}
                            initial={{ opacity: 0, y: 10, scale: 0.8, x: '-50%' }}
                            animate={{ opacity: 1, y: 0, scale: 1, x: '-50%' }}
                            exit={{ opacity: 0, y: 10, scale: 0.8, x: '-50%' }}
                        >
                            Edit
                        </EditButton>
                    )}
                </AnimatePresence>
            )}
        </Wrapper>
    );
}
